export default "__VITE_ASSET__ChMVKd9M__"